import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Riya Mehta",
    city: "Mumbai",
    quote:
      "The rikshaw rolled up to my Bandra balcony. I felt like a queen choosing pieces from a moving showroom.",
    rating: 5,
  },
  {
    name: "Aanya Sharma",
    city: "Jaipur",
    quote:
      "The quality is breathtaking. The driver let me try four pieces before I picked my favorite. Pure magic.",
    rating: 5,
  },
  {
    name: "Priya Reddy",
    city: "Hyderabad",
    quote:
      "Wore my polki jhumkas to a wedding and three friends asked. JewelleryOnWheels is now my best-kept secret.",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section
      className="py-20 md:py-28 bg-white border-y border-jow-navy/10"
      data-testid="home-testimonials"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="label-overline text-jow-gold">Loved By</span>
          <h2 className="font-display text-4xl md:text-5xl mt-3 text-jow-navy">
            What our patrons say.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="border border-jow-gold/30 bg-jow-cream p-8 md:p-10"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex gap-1 text-jow-gold mb-5">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} size={14} fill="#D4AF37" stroke="#D4AF37" />
                ))}
              </div>
              <blockquote className="font-display text-xl text-jow-navy leading-snug">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6">
                <p className="font-sans text-sm text-jow-navy">{t.name}</p>
                <p className="label-overline text-jow-navy/55 mt-1">{t.city}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
